import { render } from "./BreadcrumbBackIcon.vue?vue&type=template&id=7bcbabc3"
import script from "./BreadcrumbBackIcon.vue?vue&type=script&lang=js"
export * from "./BreadcrumbBackIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__